import Box from "@mui/material/Box";
import Grid from "components/primitives/Grid";
import AthleteName from "components/AthleteName";
import MonitoringIndicatorsRow from "components/Monitoring/MonitoringIndicatorsRow";
import { Athlete } from "types/athlete";
import Constants from "config/Constants";
import * as Components from "./AthleteTableRow.components";
import { memo, useMemo } from "react";
import GroupColorBlocks from "./GroupColorBlocks";
import { tableCells } from "../AthleteTable.config";
import CanDoAction from "components/CanDoAction";
import Tooltip from "components/Tooltip";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { useTranslation } from "react-i18next";
import AthleteTableRowCheckboxContainer from "./AthleteTableRowCheckboxContainer";

interface AthleteTableRowProps {
  athlete: Athlete;
}

function AthleteTableRow(props: AthleteTableRowProps) {
  const { athlete } = props;
  const { t } = useTranslation();

  const athleteLastMeasurementTest = useMemo(() => {
    return athlete.lastTested
      ? moment(athlete.lastTested).fromNow()
      : t("athlete.last_measurement_tooltip_no_measurements_text");
  }, [athlete.lastTested, t]);

  return (
    <Box
      key={athlete.id}
      component={Components.TableRowButton}
      variant="text"
      href={`${Constants.routes.athletes.route}/${athlete.id}`}
    >
      <Grid container width="100%" alignItems="center" minHeight={56}>
        <Grid {...tableCells.groupColorBlocks}>
          <CanDoAction action="group.view">
            <Components.ColorBlocksContainer>
              <GroupColorBlocks {...props.athlete} />
            </Components.ColorBlocksContainer>
          </CanDoAction>
        </Grid>
        <Grid {...tableCells.checkbox}>
          <AthleteTableRowCheckboxContainer athlete={athlete} />
        </Grid>
        <Tooltip
          title={
            <Box sx={{ p: 0.5 }}>
              <Typography
                sx={{
                  fontSize: 12,
                  color: "grey.800",
                  textAlign: "left",
                }}
              >
                {t("athlete.last_measurement_tooltip_text")}
              </Typography>
              <Typography color="primary" sx={{ textAlign: "left" }}>
                {athleteLastMeasurementTest}
              </Typography>
            </Box>
          }
          placement="left"
          arrow
        >
          <Grid {...tableCells.name}>
            <AthleteName athlete={athlete} isSearchable />
          </Grid>
        </Tooltip>
        <Grid {...tableCells.monitoringIndicators}>
          <Box sx={{ height: "100%", py: 0 }}>
            <MonitoringIndicatorsRow athleteId={athlete.id} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(AthleteTableRow);
